const progressWidget = {
  props: ['user', 'range', 'pipeline'],

  created () {
    this.get();
  },

  mounted () {
    this.$watch('user', () => this.get());
    this.$watch('range', () => this.get());
    this.$watch('pipeline', () => this.get());
  },

  data () {
    return {
      interval: 'previous',
      loading: false,
      data: {},
      list: [],
      users: {},
      types: {},
      stages: {},
      count: 0,
      total: 0,
      averageCount: 0,
      averageTotal: 0,
    };
  },

  methods: {
    get () {
      this.loading = true;

      const params = {
        user: this.user,
        range: this.range,
        pipeline: this.pipeline,
        interval: this.interval,
        group_by: this.groupBy,
      };

      this.$http.get(`/widget/append/${this.name}`, { params })
        .then((response) => {
          this.data = response.data;
        })
        .finally(() => {
          this.getAppend();
          this.getList();
          this.loading = false;
        });
    },

    waitForChartToBeRendered () {
      return new Promise((resolve) => {
        let intervalId;

        intervalId = setInterval(() => {
          if (this.loading === false) {
            console.log(`Component ${this.name} has already finished loading`);

            clearInterval(intervalId);
            return resolve(true);
          }

          console.log(`Waiting for ${this.name} chart to be rendered`);
        }, 1000)
      });
    },

    getList () {
      if (this.isValid(this.data)) {
        if (this.data.data[1]) {
          this.list = this.data.data[1].items;
        } else {
          this.list = this.data.data[0].items;
        }
      } else {
        this.list = [];
      }
    },

    getAppend () {
      if (this.data.append) {
        this.users = this.data.append.users ? this.data.append.users : {};
        this.types = this.data.append.types ? this.data.append.types : {};
        this.stages = this.data.append.stages ? this.data.append.stages : {};
      }
    },

    getTotal () {
      let total = 0;

      this.list.forEach((element) => {
        total += element.total;
      });

      return total;
    },

    getProgress (index) {
      return this.list[index].total / (this.getTotal() * 100);
    },

    getStageName (id) {
      return this.stages[id].name;
    },

    getUserName (id) {
      return this.users[id].name;
    },

    getUserEmail (id) {
      return this.users[id].email;
    },

    getUserGravatar (id) {
      return this.users[id].gravatar;
    },

    getActivityIcon (index) {
      return this.types[this.list[index].id].key;
    },

    getActivityName (index) {
      return this.types[this.list[index].id].name;
    },

    getStats (property) {
      return this.getData(1, property) - this.getData(0, property);
    },

    getData (list, property) {
      sum = 0;

      if (this.isValid(this.data)) {
        if (this.data.data[list]) {
          items = this.data.data[list].items;

          items.forEach((element) => {
            sum += element[property];
          });
        }
      }

      return sum;
    },

    getActivityStats (index) {
      return this.list[index].total - this.data.data[0].items[index].total;
    },

    periodTooltipText () {
      return 'Em relação ao período anterior.';
    },

    isValid (data = []) {
      return data.success || false;
    },
  },
};

export default progressWidget;
